







import { defineComponent } from '@nuxtjs/composition-api';

import CMSRenderer from '~/components/CMS/CMSRenderer.vue';

export default defineComponent({
  name: 'TwoColumn',
  components: {
    CMSRenderer,
  },
  props: {
    // eslint-disable-next-line vue/prop-name-casing
    column_1: {
      type: Array,
      required: true,
    },
    // eslint-disable-next-line vue/prop-name-casing
    column_2: {
      type: Array,
      required: true,
    },
  },
  setup(props) {
    return {};
  },
});
